/**
 * Convert return value with neg when call a predicate function
 * @param predicate
 * @return {()=>number}
 */
const neg = (predicate: () => number)=> {
  return function (...args) {
    return - predicate.apply(null, args);
  };
};
export default neg;



// WEBPACK FOOTER //
// ./src/neg.ts